module.exports = __webpack_public_path__ + "static/media/EstefaniaDeRosa_cv_en.617f450e.pdf";